const SIDEBAR_BACKGROUND_COLOR = '#3280CE' as const;

export { SIDEBAR_BACKGROUND_COLOR };
